import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AdjustModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Sun/brightness icon - half filled circle with rays */}
      {/* Left half (dark) */}
      <path
        d="M12 5a7 7 0 0 0 0 14V5z"
        fill={color}
      />
      {/* Right half (light - outline only) */}
      <path
        d="M12 5a7 7 0 0 1 0 14"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {/* Top ray */}
      <path d="M12 1v2" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      {/* Bottom ray */}
      <path d="M12 21v2" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      {/* Left ray */}
      <path d="M3 12h2" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      {/* Right ray */}
      <path d="M19 12h2" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
    </BaseIcon>
  ),
);

AdjustModeIcon.displayName = 'AdjustModeIcon';
